import { request } from "@shared/utils";
import { API, METHODS } from "@shared/constants";
import { BuyBoxPresetDto } from "@shared/interfaces/PresetBuilder.interface";
import {
  ExportNeighborhoodsToCSVQuery,
  ZipsToCSVQueryParams,
  GetBuyBoxDataQuery,
  GetNeighborhoodQuery,
  GetZipsQuery,
} from "@shared/interfaces";

export default {
  getCountyMetrics: (payload: { county: string }) => {
    const { county } = payload;
    return request(METHODS.GET, API.MARKET_MAP.GET_COUNTY_METRICS(county))();
  },
  getZipMetrics: (payload: { county: string; zip: string }) => {
    const { county, zip } = payload;
    return request(METHODS.GET, API.MARKET_MAP.GET_ZIP_METRICS(county, zip))();
  },

  getZips(payload: { accountID: number; county: string; zipsOnly?: boolean }) {
    const { accountID, county, zipsOnly = true } = payload;
    return request(METHODS.GET, API.MARKET_MAP.GET_ZIP_CODES(accountID, county, zipsOnly))();
  },

  getCities(payload: { county: number | number[] }) {
    return request(METHODS.GET, API.MARKET_MAP.GET_CITIES())({ params: { county_id: payload.county } });
  },
  getNeighborhoods(payload: { county: number | number[] }) {
    return request(METHODS.GET, API.MARKET_MAP.GET_NEIGHBORHOODS())({ params: { county_id: payload.county } });
  },
  getZipsPaginated(payload: GetZipsQuery) {
    const { from, size, state, fips, zip } = payload;
    return request(
      METHODS.GET,
      API.MARKET_MAP.GET_ZIPS_TABLE({
        from,
        fips,
        size: size,
        state: state,
        zip: zip,
      }),
    )();
  },
  getNeighborhoodsPaginated: (payload: GetNeighborhoodQuery) =>
    request(METHODS.GET, API.MARKET_MAP.GET_NEIGHBORHOODS_TABLE)({ params: payload }),
  getBuyBoxData(payload: GetBuyBoxDataQuery) {
    return request(METHODS.GET, API.MARKET_MAP.GET_FILTERED_BUY_BOX_DATA(payload))();
  },
  getPresetBuyBoxData(payload: BuyBoxPresetDto) {
    return request(METHODS.GET, API.MARKET_MAP.GET_PRESET_BUY_BOX_DATA(payload))();
  },
  exportZipsToCSV(payload: ZipsToCSVQueryParams) {
    const { state, zip, fips } = payload;
    return request(
      METHODS.GET,
      API.MARKET_MAP.EXPORT_ZIPS_TO_CSV({
        fips,
        state,
        zip,
      }),
    )({ responseType: "blob" });
  },
  neighborhoodsZipsToCSV(params: ExportNeighborhoodsToCSVQuery) {
    return request(METHODS.GET, API.MARKET_MAP.EXPORT_NEIGHBORHOODS_ZIPS_TO_CSV)({ responseType: "blob", params });
  },
  getCountyGeoDataByCode(code: string) {
    return request(METHODS.GET, API.MARKET_MAP.GET_COUNTY_GEO_DATA(code))();
  },
  getCountyNeighborhoodsGeoDataByCountyCode(code: string) {
    return request(METHODS.GET, API.MARKET_MAP.GET_COUNTY_NEIGHBORHOODS_GEO_DATA(code))();
  },
  getCountyNeighborhoodMetricsByECId(ecId: string) {
    return request(METHODS.GET, API.MARKET_MAP.GET_COUNTY_NEIGHBORHOOD_METRICS_BY_ES_ID(ecId))();
  },
};
